module.exports = __webpack_public_path__ + "static/media/html5.0bd1a066.png";